module.exports = __webpack_public_path__ + "static/media/barrio-chino.3a97b27f.md";